/**
 * @flow
 * @relayHash 27257efd0dacdeb4f314034af0163f98
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TenantExchangeFeeTemplateCreateMutationVariables = {|
  tenantId: string,
  exchangeId: string,
  feeTemplateId: string,
|};
export type TenantExchangeFeeTemplateCreateMutationResponse = {|
  +createTenantExchangeFeeTemplate: ?{|
    +tenant: ?{|
      +id: string,
      +tenantexchangefeetemplateSet: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +createdAt: any,
            +exchange: {|
              +id: string,
              +symbol: string,
            |},
            +tenant: {|
              +id: string,
              +name: string,
            |},
            +feeTemplate: {|
              +id: string,
              +name: string,
            |},
          |}
        |}>
      |},
    |}
  |}
|};
export type TenantExchangeFeeTemplateCreateMutation = {|
  variables: TenantExchangeFeeTemplateCreateMutationVariables,
  response: TenantExchangeFeeTemplateCreateMutationResponse,
|};
*/


/*
mutation TenantExchangeFeeTemplateCreateMutation(
  $tenantId: ID!
  $exchangeId: ID!
  $feeTemplateId: ID!
) {
  createTenantExchangeFeeTemplate(tenantId: $tenantId, exchangeId: $exchangeId, feeTemplateId: $feeTemplateId) {
    tenant {
      id
      tenantexchangefeetemplateSet {
        edges {
          node {
            id
            createdAt
            exchange {
              id
              symbol
            }
            tenant {
              id
              name
            }
            feeTemplate {
              id
              name
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "tenantId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "exchangeId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "feeTemplateId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
],
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createTenantExchangeFeeTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "exchangeId",
        "variableName": "exchangeId"
      },
      {
        "kind": "Variable",
        "name": "feeTemplateId",
        "variableName": "feeTemplateId"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }
    ],
    "concreteType": "CreateTenantExchangeFeeTemplate",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantexchangefeetemplateSet",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantExchangeFeeTemplateNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TenantExchangeFeeTemplateNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantExchangeFeeTemplateNode",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "exchange",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ExchangeNode",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tenant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "plural": false,
                        "selections": (v2/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "feeTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FeeTemplateNode",
                        "plural": false,
                        "selections": (v2/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TenantExchangeFeeTemplateCreateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "TenantExchangeFeeTemplateCreateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "TenantExchangeFeeTemplateCreateMutation",
    "id": null,
    "text": "mutation TenantExchangeFeeTemplateCreateMutation(\n  $tenantId: ID!\n  $exchangeId: ID!\n  $feeTemplateId: ID!\n) {\n  createTenantExchangeFeeTemplate(tenantId: $tenantId, exchangeId: $exchangeId, feeTemplateId: $feeTemplateId) {\n    tenant {\n      id\n      tenantexchangefeetemplateSet {\n        edges {\n          node {\n            id\n            createdAt\n            exchange {\n              id\n              symbol\n            }\n            tenant {\n              id\n              name\n            }\n            feeTemplate {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '49e83454819daadf3aa5401aa68b2fcb';
module.exports = node;
